module.exports = __webpack_public_path__ + "static/media/pltlogo.9dfe6be4.webp";